/* Copyright 2021, Milkdown by Mirone. */
import { parserCtx, schemaCtx, serializerCtx } from '@milkdown/core';
import { createProsePlugin } from '@milkdown/utils';
import { Slice } from 'prosemirror-model';
import { Plugin } from 'prosemirror-state';
const isPureText = (content) => {
    if (!content)
        return false;
    if (Array.isArray(content)) {
        if (content.length > 1)
            return false;
        return isPureText(content[0]);
    }
    const child = content.content;
    if (child) {
        return isPureText(child);
    }
    return content.type === 'text';
};
export const clipboardPlugin = createProsePlugin((_, utils) => {
    const { ctx } = utils;
    const schema = ctx.get(schemaCtx);
    const parser = ctx.get(parserCtx);
    const serializer = ctx.get(serializerCtx);
    return new Plugin({
        props: {
            handlePaste: (view, event) => {
                var _a, _b, _c;
                const editable = (_b = (_a = view.props).editable) === null || _b === void 0 ? void 0 : _b.call(_a, view.state);
                const { clipboardData } = event;
                if (!editable || !clipboardData) {
                    return false;
                }
                const text = clipboardData.getData('text/plain');
                const html = clipboardData.getData('text/html');
                if (html.length > 0) {
                    return false;
                }
                const slice = parser(text);
                if (!slice || typeof slice === 'string')
                    return false;
                const { $from } = view.state.selection;
                const isEmpty = $from.node().content.size === 0;
                const isNestedSlice = ((_c = slice.firstChild) === null || _c === void 0 ? void 0 : _c.type.name) !== 'paragraph';
                const depth = isEmpty || isNestedSlice ? 0 : $from.depth;
                view.dispatch(view.state.tr.replaceSelection(new Slice(slice.content, depth, depth)));
                return true;
            },
            clipboardTextSerializer: (slice) => {
                const isText = isPureText(slice.content.toJSON());
                if (isText) {
                    return slice.content.textBetween(0, slice.content.size, '\n\n');
                }
                const doc = schema.topNodeType.createAndFill(undefined, slice.content);
                if (!doc)
                    return '';
                const value = serializer(doc);
                return value;
            },
        },
    });
});
//# sourceMappingURL=clipboard.js.map